"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import { SectionHeader } from "fansunited-sports-ui";
// Team-specific components
import { MatchHighlight } from "../../partials/MatchHighlight";
import { LiveMatchHighlight } from "../../partials/LiveMatchHighlight";
import { MatchPredictionCard } from "../../partials/MatchPredictionCard/MatchPredictionCard";
import { TeamForm } from "../../partials/TeamForm";
import { TeamStats } from "../../partials/TeamStats";
import { TeamClubInfo } from "../../partials/TeamClubInfo";
import { TeamFeaturedPlayers } from "../../partials/TeamFeaturedPlayers";
import { LatestNewsGrid } from "@/components/articles/LatestNewsGrid";
import { MatchList } from "@/components/matches";
import { useTeamLogoUrl } from "@/components/ui/TeamLogo";
import { mapEventToMatchListItem } from "@/utilities/mappers/adaptedEventToMatchListItem";
import { toSDKMatches } from "../../utils/toSDKMatches";
import { useTeamPageData } from "../../context/TeamPageDataContext";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { useCompetitionProfileOptional } from "@/features/competition-profiles/CompetitionProfileProvider";
import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
const OVERVIEW_ARTICLES_LIMIT = 3;
interface OverviewTabProps {
  onNavigateToSquad?: () => void;
}
export const OverviewTab: React.FC<OverviewTabProps> = t0 => {
  const $ = _c(52);
  const {
    onNavigateToSquad
  } = t0;
  const labels = useLabels().teamPage;
  const {
    team,
    events,
    getArticles
  } = useTeamPageData();
  const {
    predictorLeaderboardId
  } = useTenantSettings();
  const competitionProfile = useCompetitionProfileOptional();
  const nav = useNavigation();
  const logoUrl = useTeamLogoUrl();
  const isPredictorEnabled = Boolean(predictorLeaderboardId);
  const isNationalTeam = team.type === "national";
  const showSeasonStats = !isNationalTeam && competitionProfile?.features.leagueStandings !== false;
  let t1;
  if ($[0] !== events || $[1] !== team.id) {
    const liveMatches = events.filter(_temp);
    let t2;
    if ($[3] !== team.id) {
      t2 = event_0 => event_0.competitorOne.id === team.id || event_0.competitorTwo.id === team.id;
      $[3] = team.id;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = liveMatches.find(t2);
    $[0] = events;
    $[1] = team.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const teamLiveMatch = t1;
  let t2;
  bb0: {
    if (!isNationalTeam) {
      let t3;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t2 = t3;
      break bb0;
    }
    let t3;
    if ($[6] !== events || $[7] !== logoUrl || $[8] !== nav.match || $[9] !== team.id) {
      let t4;
      if ($[11] !== team.id) {
        t4 = e => {
          const isTeamMatch = e.competitorOne.id === team.id || e.competitorTwo.id === team.id;
          return isTeamMatch && e.status?.type?.toUpperCase() === "FINISHED";
        };
        $[11] = team.id;
        $[12] = t4;
      } else {
        t4 = $[12];
      }
      let t5;
      if ($[13] !== logoUrl || $[14] !== nav.match) {
        t5 = e_0 => mapEventToMatchListItem(e_0, true, false, nav.match, logoUrl);
        $[13] = logoUrl;
        $[14] = nav.match;
        $[15] = t5;
      } else {
        t5 = $[15];
      }
      t3 = events.filter(t4).sort(_temp2).slice(0, 10).map(t5);
      $[6] = events;
      $[7] = logoUrl;
      $[8] = nav.match;
      $[9] = team.id;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = t3;
  }
  const recentResults = t2;
  let t3;
  if ($[16] !== teamLiveMatch) {
    t3 = teamLiveMatch && <section><LiveMatchHighlight match={teamLiveMatch} /></section>;
    $[16] = teamLiveMatch;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section><div className="grid grid-cols-1 lg:grid-cols-2 gap-6"><MatchHighlight type="latest" /><MatchHighlight type="upcoming" /></div></section>;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== competitionProfile?.features.teamForm || $[20] !== events || $[21] !== isNationalTeam || $[22] !== labels.fixtures || $[23] !== labels.form || $[24] !== recentResults || $[25] !== showSeasonStats || $[26] !== team.assets?.logo || $[27] !== team.country?.code || $[28] !== team.country?.flag || $[29] !== team.id || $[30] !== team.metadata?.branding?.primaryColor || $[31] !== team.metadata?.branding?.secondaryColor || $[32] !== team.name) {
    t5 = (competitionProfile?.features.teamForm !== false || showSeasonStats) && <section>{isNationalTeam ? competitionProfile?.features.teamForm !== false && <div><SectionHeader entity={{
          name: labels.form.recentForm,
          styles: {
            typography: {
              name: "text-sm uppercase font-semibold text-foreground"
            }
          }
        }} styles={{
          container: "mb-2"
        }} /><MatchList matches={recentResults} variant="teamResults" emptyMessage={labels.fixtures.noPastResults} /></div> : <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">{competitionProfile?.features.teamForm !== false && <TeamForm teamId={team.id} matches={toSDKMatches(events)} teamName={team.name} teamLogo={team.assets?.logo} teamCountryCode={team.country?.code} teamCountryFlag={team.country?.flag} teamPrimaryColor={team.metadata?.branding?.primaryColor} teamSecondaryColor={team.metadata?.branding?.secondaryColor} headerLabel={labels.form.recentForm} />}{showSeasonStats && <TeamStats teamId={team.id} />}</div>}</section>;
    $[19] = competitionProfile?.features.teamForm;
    $[20] = events;
    $[21] = isNationalTeam;
    $[22] = labels.fixtures;
    $[23] = labels.form;
    $[24] = recentResults;
    $[25] = showSeasonStats;
    $[26] = team.assets?.logo;
    $[27] = team.country?.code;
    $[28] = team.country?.flag;
    $[29] = team.id;
    $[30] = team.metadata?.branding?.primaryColor;
    $[31] = team.metadata?.branding?.secondaryColor;
    $[32] = team.name;
    $[33] = t5;
  } else {
    t5 = $[33];
  }
  let t6;
  if ($[34] !== isPredictorEnabled) {
    t6 = isPredictorEnabled && <section><MatchPredictionCard /></section>;
    $[34] = isPredictorEnabled;
    $[35] = t6;
  } else {
    t6 = $[35];
  }
  let t7;
  if ($[36] !== getArticles) {
    t7 = getArticles().slice(0, OVERVIEW_ARTICLES_LIMIT);
    $[36] = getArticles;
    $[37] = t7;
  } else {
    t7 = $[37];
  }
  let t8;
  if ($[38] !== labels.news.latestNews || $[39] !== t7) {
    t8 = <LatestNewsGrid articles={t7} title={labels.news.latestNews} />;
    $[38] = labels.news.latestNews;
    $[39] = t7;
    $[40] = t8;
  } else {
    t8 = $[40];
  }
  let t9;
  if ($[41] !== onNavigateToSquad) {
    t9 = <div className="lg:col-span-2"><TeamFeaturedPlayers onViewAll={onNavigateToSquad} /></div>;
    $[41] = onNavigateToSquad;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  let t10;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div><TeamClubInfo /></div>;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  let t11;
  if ($[44] !== t9) {
    t11 = <section><div className="grid grid-cols-1 lg:grid-cols-3 gap-6">{t9}{t10}</div></section>;
    $[44] = t9;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] !== t11 || $[47] !== t3 || $[48] !== t5 || $[49] !== t6 || $[50] !== t8) {
    t12 = <div className="space-y-8">{t3}{t4}{t5}{t6}{t8}{t11}</div>;
    $[46] = t11;
    $[47] = t3;
    $[48] = t5;
    $[49] = t6;
    $[50] = t8;
    $[51] = t12;
  } else {
    t12 = $[51];
  }
  return t12;
};
function _temp(event) {
  return event.status?.type === "LIVE";
}
function _temp2(a, b) {
  return new Date(b.date).getTime() - new Date(a.date).getTime();
}